"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCAL_STORAGE_EXPIRY_KEY = exports.EXEMPTED_COOKIES = exports.DEFAULT_EXPIRY_DAYS = exports.DEFAULT_DOMAIN = exports.DEFAULT_COOKIE_SIZE_THRESHOLD = void 0;
var LOCAL_STORAGE_EXPIRY_KEY = 'aa_cookie_expiry';
exports.LOCAL_STORAGE_EXPIRY_KEY = LOCAL_STORAGE_EXPIRY_KEY;
var DEFAULT_DOMAIN = 'www.airasia.com';
exports.DEFAULT_DOMAIN = DEFAULT_DOMAIN;
var DEFAULT_EXPIRY_DAYS = 5;
exports.DEFAULT_EXPIRY_DAYS = DEFAULT_EXPIRY_DAYS;
var DEFAULT_COOKIE_SIZE_THRESHOLD = 4096; // 4Kb

exports.DEFAULT_COOKIE_SIZE_THRESHOLD = DEFAULT_COOKIE_SIZE_THRESHOLD;
var EXEMPTED_COOKIES = ['__airasiaga', '__airasiaga_gid']; // Cookies that are exempted on deletion

exports.EXEMPTED_COOKIES = EXEMPTED_COOKIES;